(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/fraction-flow/assets/javascripts/fraction-payment-flow.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/fraction-flow/assets/javascripts/fraction-payment-flow.js');
"use strict";


const createPayment = svs.components.payment.payment.createPayment;
const marketplaceGroups = svs.components.payment.middleware.marketplaceGroups;
const authenticated = svs.components.payment.middleware.authenticated.authenticated;
const _svs$components$wager = svs.components.wagerPaymentFlow.fractionFlow.middlewareSetup,
  accountBalanceMw = _svs$components$wager.accountBalanceMw,
  spelpausMw = _svs$components$wager.spelpausMw,
  paymentConfirmMw = _svs$components$wager.paymentConfirmMw,
  paymentDoneMw = _svs$components$wager.paymentDoneMw,
  marketplaceMultipleSharesMW = _svs$components$wager.marketplaceMultipleSharesMW,
  timeLimitsMw = _svs$components$wager.timeLimitsMw;
const FractionService = svs.components.payment.serviceFraction.FractionService;

const createFractionPaymentFlow = _ref => {
  let config = _ref.config,
    fraction = _ref.fraction;
  const paymentBuilder = createPayment(new FractionService(config)).addPayable(fraction).addPreMiddleware(authenticated).addPreMiddleware(spelpausMw).addPreMiddleware(timeLimitsMw).addPreMiddleware(accountBalanceMw).addPreMiddleware(marketplaceGroups).addPreMiddleware(marketplaceMultipleSharesMW).addPreMiddleware(paymentConfirmMw).addPostMiddleware(paymentDoneMw);
  return paymentBuilder;
};
setGlobal('svs.components.wagerPaymentFlow.fractionFlow.createFractionPaymentFlow', createFractionPaymentFlow);

 })(window);